// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fax-varules {
  overflow: hidden;
  height: 78vh;
  max-height: 78vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.fax-varules__header {
  background-color: #1f2677;
  color: #fff;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: none;
  flex-shrink: 0;
}

.fax-varules__title {
  font-weight: 600;
  display: flex;
  align-items: center;
}

.fax-varules__badge {
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 3px;
  padding: 1px 7px;
}

.fax-varules__body {
  padding: 12px 16px 16px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.fax-varules__stats {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.fax-varules__stat {
  flex: 1;
  border: 1px solid #e0e4f2;
  background: #f7f8fc;
  border-radius: 4px;
  padding: 8px 10px;
  text-align: left;
  cursor: pointer;
}

.fax-varules__stat.is-on {
  border-color: #1f2677;
  box-shadow: inset 0 0 0 1px #1f2677;
  background: #fff;
}

.fax-varules__stat-num {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #1f2677;
  line-height: 1.1;
}

.fax-varules__stat-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
}

.fax-varules__stat.is-active-tone .fax-varules__stat-num {
  color: #146c43;
}

.fax-varules__stat.is-inactive-tone .fax-varules__stat-num {
  color: #821b1b;
}

.fax-varules__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.fax-varules__toolbar-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.fax-varules__search-wrap {
  flex: 1;
  position: relative;
  min-width: 0;
}

.fax-varules__search {
  width: 100%;
  height: 32px;
  border: 1px solid #cfd4e6;
  border-radius: 4px;
  padding: 0 28px 0 10px;
  font-size: 13px;
}

.fax-varules__search:focus {
  outline: none;
  border-color: #1f2677;
}

.fax-varules__search-clear {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #888;
  width: 20px;
  height: 20px;
  padding: 0;
  line-height: 1;
  font-size: 18px;
  cursor: pointer;
}

.fax-varules__search-clear:hover {
  color: #444;
}

.fax-varules__icon-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.fax-varules__filter-btn.is-on {
  box-shadow: inset 0 0 0 1px rgba(31, 38, 119, 0.35);
}

.fax-varules__filter-count {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 14px;
  height: 14px;
  border-radius: 7px;
  background: #1f2677;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  line-height: 1;
}

.fax-varules__add-btn:disabled {
  opacity: 0.55;
}

.fax-varules__filter-panel {
  flex-shrink: 0;
  margin-bottom: 10px;
  border: 1px solid #e6e8f2;
  border-radius: 4px;
  background: #fafbfe;
  padding: 10px 12px;
  position: relative;
  z-index: 20;
  max-height: min(220px, 28vh);
  overflow-x: hidden;
  overflow-y: auto;
}

.fax-varules__filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
}

.fax-varules__filter-grid .fax-varules__caption {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #212529;
  margin-bottom: 3px;
}

.fax-varules__content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fax-varules__filter-auto {
  width: 100%;
}

::ng-deep .fax-varules__filter-auto .autocomplete-container {
  height: 30px;
}

::ng-deep .fax-varules__filter-auto .autocomplete-container .input-container input {
  height: 30px !important;
  font-size: 12px;
  border: 1px solid #cfd4e6;
  border-radius: 4px;
  padding: 0 8px;
}

::ng-deep .fax-varules__filter-auto .autocomplete-container.active {
  z-index: 30 !important;
  overflow: visible !important;
}

::ng-deep .fax-varules__filter-auto .autocomplete-container .suggestions-container {
  max-height: min(40vh, 240px) !important;
  overflow-y: auto !important;
}

::ng-deep .fax-varules__filter-auto .autocomplete-container .suggestions-container ul {
  max-height: min(38vh, 220px) !important;
  overflow-y: auto !important;
}

.fax-varules__filter-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.fax-varules__split {
  display: grid;
  grid-template-columns: minmax(200px, 28%) minmax(0, 1fr);
  grid-template-rows: 1fr;
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  border: 1px solid #e6e8f2;
  border-radius: 4px;
  overflow: hidden;
}

.fax-varules__pane-left {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  min-width: 0;
  overflow: hidden;
  border-right: 1px solid #e6e8f2;
  background: #fafbfe;
}

.fax-varules__pane-list {
  flex: 1 1 auto;
  height: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.fax-varules__paginator {
  flex-shrink: 0;
  margin-top: 8px;
  border: 1px solid #e6e8f2;
  border-radius: 4px;
  background: #fff;
}

::ng-deep .fax-varules__paginator.main_page_paginator .mat-mdc-paginator-container {
  min-height: 40px !important;
  max-height: 40px !important;
}

.fax-varules__pane-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 10px;
  border: none;
  border-bottom: 1px solid #eef0f7;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.fax-varules__pane-item:hover {
  background: #f0eefc;
}

.fax-varules__pane-item.is-selected {
  box-shadow: inset 3px 0 0 #821b1b;
}

.fax-varules__pane-item.is-newly-created {
  background: #edf7ed;
}

.fax-varules__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}

.fax-varules__dot.is-active {
  background: #28a745;
}

.fax-varules__dot.is-inactive {
  background: #dc3545;
}

.fax-varules__pane-text {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.fax-varules__pane-name {
  font-size: 12px;
  font-weight: 700;
  color: #1f2677;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fax-varules__pane-sub {
  font-size: 11px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fax-varules__pane-detail {
  display: flex;
  flex-direction: column;
  padding: 12px 14px 10px;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.fax-varules__detail-main {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  overscroll-behavior: contain;
  padding-right: 4px;
}

.fax-varules__detail-top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.fax-varules__detail-name {
  font-size: 15px;
  font-weight: 700;
  color: #1f2677;
  word-break: break-word;
}

.fax-varules__detail-id {
  font-size: 12px;
  margin-top: 4px;
}

.fax-varules__detail-id-label {
  font-weight: 600;
  color: #495057;
}

.fax-varules__detail-id-sep {
  margin: 0 4px;
  color: #495057;
}

.fax-varules__detail-id-value {
  font-weight: 700;
  color: #343a40;
}

.fax-varules__detail-desc-block {
  margin: 0 0 14px;
  padding: 8px 10px;
  background: #f4f6fb;
  border-left: 3px solid #8a91b0;
  border-radius: 0 4px 4px 0;
  flex: 0 0 auto;
}

.fax-varules__detail-desc-block .fax-varules__caption {
  display: block;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #212529;
}

.fax-varules__detail-desc {
  font-size: 12px;
  color: #212529;
  font-weight: 500;
  margin: 0;
  line-height: 1.45;
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  word-break: break-word;
  padding-right: 6px;
}

.fax-varules__detail-desc::-webkit-scrollbar {
  width: 6px;
}

.fax-varules__detail-desc::-webkit-scrollbar-thumb {
  background: #c5cad8;
  border-radius: 3px;
}

.fax-varules__detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 20px;
  flex: 0 0 auto;
  min-height: 0;
  margin-bottom: 4px;
}

.fax-varules__detail-grid .fax-varules__caption {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8a91b0;
  margin-bottom: 4px;
}

.fax-varules__detail-grid div > div {
  font-size: 12px;
  color: #212529;
  font-weight: 700;
  line-height: 1.35;
  word-break: break-word;
}

.fax-varules__detail-main::-webkit-scrollbar,
.fax-varules__filter-panel::-webkit-scrollbar {
  width: 6px;
}

.fax-varules__detail-main::-webkit-scrollbar-thumb,
.fax-varules__filter-panel::-webkit-scrollbar-thumb {
  background: #c5cad8;
  border-radius: 3px;
}

.fax-varules__detail-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid #eef0f7;
}

.fax-varules__empty {
  padding: 40px 16px;
  text-align: center;
  color: #6c757d;
  font-size: 13px;
  border: 1px dashed #d5d9ea;
  border-radius: 4px;
}

.fax-varules__excl-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.fax-varules__excl-title {
  flex: 1;
  min-width: 0;
  font-weight: 700;
  color: #1f2677;
}

.fax-varules__excl-sub {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  margin-top: 2px;
}

.fax-varules__excl-view {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.fax-varules__excl-form {
  flex-shrink: 0;
  background: #f7f9fc;
  border: 1px solid #e2e6f0;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 12px;
}

.fax-varules__excl-form-top {
  margin-bottom: 10px;
}

.fax-varules__excl-form-label {
  font-size: 13px;
  font-weight: 700;
  color: #1f2677;
}

.fax-varules__excl-form-grid {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) minmax(180px, 1.2fr) auto;
  gap: 12px;
  align-items: end;
}

.fax-varules__excl-field {
  position: relative;
}

.fax-varules__excl-field label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #495057;
}

.fax-varules__excl-auto {
  width: 100%;
}

::ng-deep .fax-varules__excl-auto .autocomplete-container.active {
  z-index: 40 !important;
  overflow: visible !important;
}

.fax-varules__excl-select-wrap {
  position: relative;
}

.fax-varules__excl-select-wrap.has-value select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
  padding-right: 28px;
}

.fax-varules__excl-select-wrap.has-value select::-ms-expand {
  display: none;
}

.fax-varules__excl-field .form-control::placeholder,
.fax-varules__excl-field select.is-placeholder {
  color: #6c757d;
  opacity: 1;
  font-weight: 400;
  font-style: normal;
}

.fax-varules__excl-field select:not(.is-placeholder),
.fax-varules__excl-field select option {
  color: #212529;
}

.fax-varules__excl-clear-type {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #6c757d;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  font-size: 12px;
  z-index: 1;
}

.fax-varules__excl-clear-type:hover {
  color: #821b1b;
}

.fax-varules__excl-form-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 1px;
}

.fax-varules__excl-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  border: 1px solid #e2e6f0;
  border-radius: 6px;
  background: #fff;
}

.fax-varules__excl-table {
  font-size: 13px;
}

.fax-varules__excl-table thead th {
  background: #129ab3;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  border: none;
  padding: 9px 12px;
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: nowrap;
}

.fax-varules__excl-table tbody td {
  padding: 9px 12px;
  vertical-align: middle;
  border-color: #eef0f6;
}

.fax-varules__excl-table tbody tr:hover {
  background: #f8fafc;
}

.fax-varules__excl-table tbody tr.is-editing {
  background: #e8f7fb;
  outline: 1px solid #9ad6e4;
}

.fax-varules__excl-id {
  font-weight: 700;
  color: #1f2677;
  width: 110px;
}

.fax-varules__excl-entityid {
  word-break: break-all;
}

.fax-varules__excl-row-actions {
  white-space: nowrap;
  width: 110px;
}

.fax-varules__excl-edit {
  background-color: #e8ebff;
  border: 1px solid #404090;
  color: #303090;
  min-width: 30px;
}

.fax-varules__excl-delete {
  background-color: #ffe3e3;
  border: 1px solid #821b1b;
  color: #821b1b;
  margin-left: 6px;
  min-width: 30px;
}

@media (max-width: 720px) {
  .fax-varules__excl-form-grid {
    grid-template-columns: 1fr;
  }
  .fax-varules__excl-form-actions {
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/fax-varules/fax-varules.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,OAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mCAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAAF;;AAGA;EACE,OAAA;EACA,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mDAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,sBAAA;EACA,4BAAA;AAAF;;AAGA;EACE,uCAAA;EACA,2BAAA;AAAF;;AAGA;EACE,uCAAA;EACA,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,wDAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,2BAAA;EACA,2BAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAAF;;AAGA;EACE,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAGA;;EAEE,UAAA;AAAF;;AAGA;;EAEE,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mEAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,sBAAA;EACA,4BAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,sBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;EACA,YAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE;IACE,0BAAA;EAAF;EAGA;IACE,2BAAA;EADF;AACF","sourcesContent":[".fax-varules {\r\n  overflow: hidden;\r\n  height: 78vh;\r\n  max-height: 78vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n}\r\n\r\n.fax-varules__header {\r\n  background-color: #1f2677;\r\n  color: #fff;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 16px;\r\n  border-bottom: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n\r\n.fax-varules__title {\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.fax-varules__badge {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  background: rgba(255, 255, 255, 0.18);\r\n  border: 1px solid rgba(255, 255, 255, 0.35);\r\n  border-radius: 3px;\r\n  padding: 1px 7px;\r\n}\r\n\r\n.fax-varules__body {\r\n  padding: 12px 16px 16px;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.fax-varules__stats {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fax-varules__stat {\r\n  flex: 1;\r\n  border: 1px solid #e0e4f2;\r\n  background: #f7f8fc;\r\n  border-radius: 4px;\r\n  padding: 8px 10px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.fax-varules__stat.is-on {\r\n  border-color: #1f2677;\r\n  box-shadow: inset 0 0 0 1px #1f2677;\r\n  background: #fff;\r\n}\r\n\r\n.fax-varules__stat-num {\r\n  display: block;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #1f2677;\r\n  line-height: 1.1;\r\n}\r\n\r\n.fax-varules__stat-label {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #6c757d;\r\n}\r\n\r\n.fax-varules__stat.is-active-tone .fax-varules__stat-num {\r\n  color: #146c43;\r\n}\r\n\r\n.fax-varules__stat.is-inactive-tone .fax-varules__stat-num {\r\n  color: #821b1b;\r\n}\r\n\r\n.fax-varules__toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fax-varules__toolbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fax-varules__search-wrap {\r\n  flex: 1;\r\n  position: relative;\r\n  min-width: 0;\r\n}\r\n\r\n.fax-varules__search {\r\n  width: 100%;\r\n  height: 32px;\r\n  border: 1px solid #cfd4e6;\r\n  border-radius: 4px;\r\n  padding: 0 28px 0 10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.fax-varules__search:focus {\r\n  outline: none;\r\n  border-color: #1f2677;\r\n}\r\n\r\n.fax-varules__search-clear {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 6px;\r\n  transform: translateY(-50%);\r\n  border: none;\r\n  background: transparent;\r\n  color: #888;\r\n  width: 20px;\r\n  height: 20px;\r\n  padding: 0;\r\n  line-height: 1;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.fax-varules__search-clear:hover {\r\n  color: #444;\r\n}\r\n\r\n.fax-varules__icon-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  padding: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n\r\n.fax-varules__filter-btn.is-on {\r\n  box-shadow: inset 0 0 0 1px rgba(31, 38, 119, 0.35);\r\n}\r\n\r\n.fax-varules__filter-count {\r\n  position: absolute;\r\n  top: -5px;\r\n  right: -5px;\r\n  min-width: 14px;\r\n  height: 14px;\r\n  border-radius: 7px;\r\n  background: #1f2677;\r\n  color: #fff;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 3px;\r\n  line-height: 1;\r\n}\r\n\r\n.fax-varules__add-btn:disabled {\r\n  opacity: 0.55;\r\n}\r\n\r\n.fax-varules__filter-panel {\r\n  flex-shrink: 0;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #e6e8f2;\r\n  border-radius: 4px;\r\n  background: #fafbfe;\r\n  padding: 10px 12px;\r\n  position: relative;\r\n  z-index: 20;\r\n  max-height: min(220px, 28vh);\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.fax-varules__filter-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px 12px;\r\n}\r\n\r\n.fax-varules__filter-grid .fax-varules__caption {\r\n  display: block;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: #212529;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.fax-varules__content {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.fax-varules__filter-auto {\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .fax-varules__filter-auto .autocomplete-container {\r\n  height: 30px;\r\n}\r\n\r\n::ng-deep .fax-varules__filter-auto .autocomplete-container .input-container input {\r\n  height: 30px !important;\r\n  font-size: 12px;\r\n  border: 1px solid #cfd4e6;\r\n  border-radius: 4px;\r\n  padding: 0 8px;\r\n}\r\n\r\n::ng-deep .fax-varules__filter-auto .autocomplete-container.active {\r\n  z-index: 30 !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n::ng-deep .fax-varules__filter-auto .autocomplete-container .suggestions-container {\r\n  max-height: min(40vh, 240px) !important;\r\n  overflow-y: auto !important;\r\n}\r\n\r\n::ng-deep .fax-varules__filter-auto .autocomplete-container .suggestions-container ul {\r\n  max-height: min(38vh, 220px) !important;\r\n  overflow-y: auto !important;\r\n}\r\n\r\n.fax-varules__filter-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.fax-varules__split {\r\n  display: grid;\r\n  grid-template-columns: minmax(200px, 28%) minmax(0, 1fr);\r\n  grid-template-rows: 1fr;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  height: 0;\r\n  border: 1px solid #e6e8f2;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.fax-varules__pane-left {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  height: 100%;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  border-right: 1px solid #e6e8f2;\r\n  background: #fafbfe;\r\n}\r\n\r\n.fax-varules__pane-list {\r\n  flex: 1 1 auto;\r\n  height: 0;\r\n  min-height: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.fax-varules__paginator {\r\n  flex-shrink: 0;\r\n  margin-top: 8px;\r\n  border: 1px solid #e6e8f2;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n}\r\n\r\n::ng-deep .fax-varules__paginator.main_page_paginator .mat-mdc-paginator-container {\r\n  min-height: 40px !important;\r\n  max-height: 40px !important;\r\n}\r\n\r\n.fax-varules__pane-item {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  padding: 8px 10px;\r\n  border: none;\r\n  border-bottom: 1px solid #eef0f7;\r\n  background: transparent;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.fax-varules__pane-item:hover {\r\n  background: #f0eefc;\r\n}\r\n\r\n.fax-varules__pane-item.is-selected {\r\n  box-shadow: inset 3px 0 0 #821b1b;\r\n}\r\n\r\n.fax-varules__pane-item.is-newly-created {\r\n  background: #edf7ed;\r\n}\r\n\r\n.fax-varules__dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  margin-top: 5px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fax-varules__dot.is-active {\r\n  background: #28a745;\r\n}\r\n\r\n.fax-varules__dot.is-inactive {\r\n  background: #dc3545;\r\n}\r\n\r\n.fax-varules__pane-text {\r\n  min-width: 0;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n}\r\n\r\n.fax-varules__pane-name {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: #1f2677;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.fax-varules__pane-sub {\r\n  font-size: 11px;\r\n  color: #6c757d;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.fax-varules__pane-detail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 12px 14px 10px;\r\n  height: 100%;\r\n  min-height: 0;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.fax-varules__detail-main {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overscroll-behavior: contain;\r\n  padding-right: 4px;\r\n}\r\n\r\n.fax-varules__detail-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.fax-varules__detail-name {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #1f2677;\r\n  word-break: break-word;\r\n}\r\n\r\n.fax-varules__detail-id {\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.fax-varules__detail-id-label {\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.fax-varules__detail-id-sep {\r\n  margin: 0 4px;\r\n  color: #495057;\r\n}\r\n\r\n.fax-varules__detail-id-value {\r\n  font-weight: 700;\r\n  color: #343a40;\r\n}\r\n\r\n.fax-varules__detail-desc-block {\r\n  margin: 0 0 14px;\r\n  padding: 8px 10px;\r\n  background: #f4f6fb;\r\n  border-left: 3px solid #8a91b0;\r\n  border-radius: 0 4px 4px 0;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.fax-varules__detail-desc-block .fax-varules__caption {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #212529;\r\n}\r\n\r\n.fax-varules__detail-desc {\r\n  font-size: 12px;\r\n  color: #212529;\r\n  font-weight: 500;\r\n  margin: 0;\r\n  line-height: 1.45;\r\n  max-height: 100px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  overscroll-behavior: contain;\r\n  word-break: break-word;\r\n  padding-right: 6px;\r\n}\r\n\r\n.fax-varules__detail-desc::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.fax-varules__detail-desc::-webkit-scrollbar-thumb {\r\n  background: #c5cad8;\r\n  border-radius: 3px;\r\n}\r\n\r\n.fax-varules__detail-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 12px 20px;\r\n  flex: 0 0 auto;\r\n  min-height: 0;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.fax-varules__detail-grid .fax-varules__caption {\r\n  display: block;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #8a91b0;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.fax-varules__detail-grid div > div {\r\n  font-size: 12px;\r\n  color: #212529;\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n  word-break: break-word;\r\n}\r\n\r\n.fax-varules__detail-main::-webkit-scrollbar,\r\n.fax-varules__filter-panel::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.fax-varules__detail-main::-webkit-scrollbar-thumb,\r\n.fax-varules__filter-panel::-webkit-scrollbar-thumb {\r\n  background: #c5cad8;\r\n  border-radius: 3px;\r\n}\r\n\r\n.fax-varules__detail-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  gap: 8px;\r\n  margin-top: auto;\r\n  padding-top: 10px;\r\n  border-top: 1px solid #eef0f7;\r\n}\r\n\r\n.fax-varules__empty {\r\n  padding: 40px 16px;\r\n  text-align: center;\r\n  color: #6c757d;\r\n  font-size: 13px;\r\n  border: 1px dashed #d5d9ea;\r\n  border-radius: 4px;\r\n}\r\n\r\n.fax-varules__excl-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fax-varules__excl-title {\r\n  flex: 1;\r\n  min-width: 0;\r\n  font-weight: 700;\r\n  color: #1f2677;\r\n}\r\n\r\n.fax-varules__excl-sub {\r\n  display: block;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #6c757d;\r\n  margin-top: 2px;\r\n}\r\n\r\n.fax-varules__excl-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.fax-varules__excl-form {\r\n  flex-shrink: 0;\r\n  background: #f7f9fc;\r\n  border: 1px solid #e2e6f0;\r\n  border-radius: 6px;\r\n  padding: 12px 14px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.fax-varules__excl-form-top {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.fax-varules__excl-form-label {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #1f2677;\r\n}\r\n\r\n.fax-varules__excl-form-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(160px, 1fr) minmax(180px, 1.2fr) auto;\r\n  gap: 12px;\r\n  align-items: end;\r\n}\r\n\r\n.fax-varules__excl-field {\r\n  position: relative;\r\n}\r\n\r\n.fax-varules__excl-field label {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.fax-varules__excl-auto {\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .fax-varules__excl-auto .autocomplete-container.active {\r\n  z-index: 40 !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n.fax-varules__excl-select-wrap {\r\n  position: relative;\r\n}\r\n\r\n.fax-varules__excl-select-wrap.has-value select {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  background-image: none;\r\n  padding-right: 28px;\r\n}\r\n\r\n.fax-varules__excl-select-wrap.has-value select::-ms-expand {\r\n  display: none;\r\n}\r\n\r\n.fax-varules__excl-field .form-control::placeholder,\r\n.fax-varules__excl-field select.is-placeholder {\r\n  color: #6c757d;\r\n  opacity: 1;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n.fax-varules__excl-field select:not(.is-placeholder),\r\n.fax-varules__excl-field select option {\r\n  color: #212529;\r\n}\r\n\r\n.fax-varules__excl-clear-type {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 8px;\r\n  transform: translateY(-50%);\r\n  border: none;\r\n  background: transparent;\r\n  color: #6c757d;\r\n  padding: 0;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  z-index: 1;\r\n}\r\n\r\n.fax-varules__excl-clear-type:hover {\r\n  color: #821b1b;\r\n}\r\n\r\n.fax-varules__excl-form-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding-bottom: 1px;\r\n}\r\n\r\n.fax-varules__excl-table-wrap {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  border: 1px solid #e2e6f0;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n}\r\n\r\n.fax-varules__excl-table {\r\n  font-size: 13px;\r\n}\r\n\r\n.fax-varules__excl-table thead th {\r\n  background: #129ab3;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  border: none;\r\n  padding: 9px 12px;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  white-space: nowrap;\r\n}\r\n\r\n.fax-varules__excl-table tbody td {\r\n  padding: 9px 12px;\r\n  vertical-align: middle;\r\n  border-color: #eef0f6;\r\n}\r\n\r\n.fax-varules__excl-table tbody tr:hover {\r\n  background: #f8fafc;\r\n}\r\n\r\n.fax-varules__excl-table tbody tr.is-editing {\r\n  background: #e8f7fb;\r\n  outline: 1px solid #9ad6e4;\r\n}\r\n\r\n.fax-varules__excl-id {\r\n  font-weight: 700;\r\n  color: #1f2677;\r\n  width: 110px;\r\n}\r\n\r\n.fax-varules__excl-entityid {\r\n  word-break: break-all;\r\n}\r\n\r\n.fax-varules__excl-row-actions {\r\n  white-space: nowrap;\r\n  width: 110px;\r\n}\r\n\r\n.fax-varules__excl-edit {\r\n  background-color: #e8ebff;\r\n  border: 1px solid #404090;\r\n  color: #303090;\r\n  min-width: 30px;\r\n}\r\n\r\n.fax-varules__excl-delete {\r\n  background-color: #ffe3e3;\r\n  border: 1px solid #821b1b;\r\n  color: #821b1b;\r\n  margin-left: 6px;\r\n  min-width: 30px;\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .fax-varules__excl-form-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .fax-varules__excl-form-actions {\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
